import {
  DEFAULT_THEME_COLOR,
  THEME_COLOR_PRESETS,
  THEME_COLOR_STORAGE_KEY,
} from '@/constants/theme';

const isBrowser = typeof window !== 'undefined';

const normalizeThemeColor = (color?: string) => {
  const value = String(color || '').trim();
  const normalized = /^#([0-9a-fA-F]{6})$/.test(value)
    ? value.toLowerCase()
    : DEFAULT_THEME_COLOR;

  return (THEME_COLOR_PRESETS as readonly string[]).includes(normalized)
    ? normalized
    : DEFAULT_THEME_COLOR;
};

export const getStoredThemeColor = () => {
  if (!isBrowser) {
    return DEFAULT_THEME_COLOR;
  }

  return normalizeThemeColor(
    window.localStorage.getItem(THEME_COLOR_STORAGE_KEY) || DEFAULT_THEME_COLOR,
  );
};

export const setStoredThemeColor = (color: string) => {
  if (!isBrowser) {
    return;
  }

  window.localStorage.setItem(
    THEME_COLOR_STORAGE_KEY,
    normalizeThemeColor(color),
  );
};

export const resolveThemeColor = (color?: string) => normalizeThemeColor(color);
